import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Menu } from "lucide-react";
import { Button } from "../ui/button";
import { retrieveData } from "../../LocalConnection/LocalConnection.js";

// ─── Page title map ───────────────────────────────────────────────────────────
const PAGE_TITLES = {
  "/dashboard": {
    title: "Overview",
    sub: "Welcome back — here's what's happening today.",
  },
  "/blogs": {
    title: "Blog Posts",
    sub: "Create and manage your blog content.",
  },
  "/blogcategories": {
    title: "Blog Categories",
    sub: "Create and manage your blog Categories content.",
  },
  "/faqs": {
    title: "FAQ Manager",
    sub: "Manage the FAQs shown on your website.",
  },
  "/testimonials": {
    title: "Testimonials",
    sub: "Manage customer reviews shown on your homepage.",
  },
  "/seo": {
    title: "SEO Manager",
    sub: "Manage meta titles, descriptions and keywords for each page.",
  },
  "/images": {
    title: "Image Library",
    sub: "Upload and manage images for your website.",
  },
  "/messages": {
    title: "Contact Messages",
    sub: "Messages sent from the Contact page form.",
  },
  "/estimates": {
    title: "Estimate Requests",
    sub: "Free estimate submissions from the homepage form.",
  },
  "/settings": {
    title: "Settings",
    sub: "Update your website contact info, hours, and social links.",
  },
};

const Topbar = ({ onMenuClick }) => {
  const location = useLocation();
  const navigate = useNavigate();

  // ─── Session check on every route change ──────────────────────────────────
  useEffect(() => {
    const admin_id = retrieveData("admin_id");
    if (!admin_id) {
      navigate("/login", { replace: true });
    }
  }, [location.pathname]);

  // ─── Derived ──────────────────────────────────────────────────────────────
  const page = PAGE_TITLES[location.pathname] || {
    title: "Dashboard",
    sub: "",
  };
  const adminName = retrieveData("admin_name") || "A";
  const avatarLetter = adminName.charAt(0).toUpperCase();

  const dateStr = new Date().toLocaleDateString("en-US", {
    weekday: "long",
    month: "long",
    day: "numeric",
    year: "numeric",
  });

  // ─── UI ───────────────────────────────────────────────────────────────────
  return (
    <header className="sticky top-0 z-30 flex h-16 shrink-0 items-center justify-between border-b border-border bg-background/80 px-4 backdrop-blur-md md:px-6">
      {/* Left */}
      <div className="flex items-center gap-4">
        <Button
          variant="ghost"
          size="icon"
          className="lg:hidden"
          onClick={onMenuClick}
        >
          <Menu className="h-5 w-5" />
        </Button>
        <div className="hidden sm:block">
          <h1 className="text-lg font-bold leading-none text-foreground">
            {page.title}
          </h1>
          <p className="mt-0.5 text-xs text-muted-foreground">{page.sub}</p>
        </div>
      </div>

      {/* Right */}
      <div className="flex items-center gap-3">
        {/* Date */}
        <span className="hidden text-xs text-muted-foreground md:block">
          {dateStr}
        </span>

        {/* Admin name */}
        <span className="hidden text-xs font-medium text-foreground sm:block">
          {adminName}
        </span>

        {/* Avatar */}
        <div className="flex h-8 w-8 items-center justify-center rounded-full bg-gradient-primary text-xs font-bold text-white shadow-glow">
          {avatarLetter}
        </div>
      </div>
    </header>
  );
};

export default Topbar;
